export const ROUTINE_SETTINGS_KEY = "forr:companion-routine-settings:v1";

export const DEFAULT_ROUTINE_SETTINGS = {
  bedtime: "22:00",
  bedtimeAvailability: "5-10",
  bodyMassNutrition: null,
};

const normalizeBodyMassNutrition = (value) => {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  return {
    enabled: Boolean(value.enabled),
    weight: Number(value.weight) || "",
    weightUnit: value.weightUnit === "kg" ? "kg" : "lb",
    height: Number(value.height) || "",
    heightUnit: value.heightUnit === "in" ? "in" : "cm",
    direction: ["gain", "maintain", "reduce", "performance"].includes(value.direction)
      ? value.direction
      : "maintain",
    targetWeight: Number(value.targetWeight) || "",
    targetDate: typeof value.targetDate === "string" ? value.targetDate : "",
    activity: ["low", "light", "moderate", "high", "veryHigh"].includes(value.activity)
      ? value.activity
      : "light",
    currentCalories: Number(value.currentCalories) || "",
    currentProtein: Number(value.currentProtein) || "",
    currentCarbs: Number(value.currentCarbs) || "",
    currentFat: Number(value.currentFat) || "",
    targetProtein: Number(value.targetProtein) || "",
    targetCarbs: Number(value.targetCarbs) || "",
    targetFat: Number(value.targetFat) || "",
    dietNotes: String(value.dietNotes || "").slice(0, 4000),
    professionalPlan: Boolean(value.professionalPlan),
    energyEffect: ["lower", "same", "higher", "unsure"].includes(value.energyEffect)
      ? value.energyEffect
      : "unsure",
    irritabilityEffect: ["lower", "same", "higher", "unsure"].includes(value.irritabilityEffect)
      ? value.irritabilityEffect
      : "unsure",
    recoveryEffect: ["better", "same", "worse", "unsure"].includes(value.recoveryEffect)
      ? value.recoveryEffect
      : "unsure",
    updatedAt: value.updatedAt || null,
  };
};

export function loadRoutineSettings() {
  try {
    const value = JSON.parse(localStorage.getItem(ROUTINE_SETTINGS_KEY) || "null");
    if (!value || typeof value !== "object") return null;
    return {
      bedtime:
        typeof value.bedtime === "string"
          ? value.bedtime
          : DEFAULT_ROUTINE_SETTINGS.bedtime,
      bedtimeAvailability:
        typeof value.bedtimeAvailability === "string"
          ? value.bedtimeAvailability
          : DEFAULT_ROUTINE_SETTINGS.bedtimeAvailability,
      bodyMassNutrition: normalizeBodyMassNutrition(value.bodyMassNutrition),
    };
  } catch (_error) {
    return null;
  }
}

export function saveRoutineSettings(settings) {
  const bodyMassNutrition = normalizeBodyMassNutrition(settings?.bodyMassNutrition);
  const value = {
    bedtime:
      typeof settings?.bedtime === "string"
        ? settings.bedtime
        : DEFAULT_ROUTINE_SETTINGS.bedtime,
    bedtimeAvailability:
      typeof settings?.bedtimeAvailability === "string"
        ? settings.bedtimeAvailability
        : DEFAULT_ROUTINE_SETTINGS.bedtimeAvailability,
    bodyMassNutrition: bodyMassNutrition
      ? { ...bodyMassNutrition, updatedAt: new Date().toISOString() }
      : null,
  };
  try {
    localStorage.setItem(ROUTINE_SETTINGS_KEY, JSON.stringify(value));
  } catch (_error) {
    // The current session can still use the returned value.
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent("companion-routine-settings-saved", { detail: value }),
    );
    window.dispatchEvent(
      new CustomEvent("apos-local-data-changed", { detail: { source: "routine-settings" } }),
    );
  }
  return value;
}
